import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    header: [],
    columns: [],
    table_columns: [],
    data: {},
    relationships: [],
    loadingStatus: "idle",
    error: null
}

export const fetchPreventivePdf = createAsyncThunk(
    'preventivePdf/fetchPreventivePdf',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = request(
                `${APP_URL}/surveys/${id}/print`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const preventivePdfSlice = createSlice({
    name: "preventivePdf",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreventivePdf.pending, state => {
                state.columns = [];
                state.table_columns = [];
                state.data = {};
                state.relationships = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchPreventivePdf.fulfilled, (state, action) => {
                state.header = action.payload.header;
                state.columns = action.payload.columns;
                state.table_columns = action.payload.table_columns;
                state.data = action.payload.data;
                state.relationships = action.payload.data.relationships;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchPreventivePdf.rejected, (state, action) => {
                state.columns = [];
                state.table_columns = [];
                state.data = {};
                state.relationships = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default preventivePdfSlice.reducer;